import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  createSubsidiarySlice,
  SubsidiarySlice,
} from "./Slices/subsidiarySlice";
import { createOrderSlice, OrderSlice } from "./Slices/orderSlice";
import { createAuthSlice, AuthSlice } from "./Slices/authSlice";
import { createMessageSlice, MessageSlice } from "./Slices/messageSlice";
import { createSectionSlice, SectionSlice } from "./Slices/sectionSlice";
import { createSystemSlice, SystemSlice } from "./Slices/systemSlice";

interface StoreState
  extends SubsidiarySlice,
    OrderSlice,
    AuthSlice,
    MessageSlice,
    SystemSlice,
    SectionSlice {}

interface CustomPersistOptions {
  name: string;
  getPartialState: (state: StoreState) => Partial<StoreState>;
}

export const useCombinedStore = create<StoreState>()(
  persist(
    (set, get, api) => ({
      ...createSubsidiarySlice(set, get, api),
      ...createOrderSlice(set, get, api),
      ...createAuthSlice(set, get, api),
      ...createMessageSlice(set, get, api),
      ...createSystemSlice(set, get, api),
      ...createSectionSlice(set, get, api),
    }),
    {
      name: "alfredo",
      getPartialState: (state) => ({
        subsidiaryDataZustand: state.subsidiaryDataZustand,
        orderDataZustand: state.orderDataZustand,
      }),
    } as CustomPersistOptions
  )
);
